import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(external)/share/$id')({
    onEnter: () => {
        document.title = 'Dostavkee - Маршрут курьера'
    },
})
